import { useRouter } from "next/dist/client/router";
import Link from "next/link";
import { useState } from "react";
import langTrans from "../components/i18n";
import Lang from "../components/lang";
import Logo from "../components/logo";
import Cookies from "js-cookie";
import { Alert } from "reactstrap";

import { forgot_password, list_associate_user } from "../pages/api/users";

const ForgotPassword = () => {
  const [Err_Email_Format, setErr_Email_Format] = useState({});
  let { locale } = useRouter();
  locale = Cookies.get("NEXT_LOCALE") ? Cookies.get("NEXT_LOCALE") : locale;
  const lang = langTrans[locale].user;


    const [userName, setName] = useState("");
    const [loginMessage, setloginMessage] = useState("");
    const [AuthFailMsg, setAuthFailMsg] = useState(false);
    const [AuthSuccessMsg, setAuthSuccessMsg] = useState(false);
    const [isVisible, setIsvisible] = useState(false)

    const router = useRouter();


    const forgotPass = async (event) => {

        event.preventDefault();

        const body = {
            "language": locale,
            "email_id": userName.trim(),
        }

        const res2 = await forgot_password(body)
        
        if (res2.status_code == 404) {
            setloginMessage(res2.message);
            setAuthFailMsg(true);
            setIsvisible(true);
            setAuthSuccessMsg(false);
        } else if (res2.status_code == 200) {
            setName("");
            setloginMessage(res2.data);
            setAuthSuccessMsg(true);
            setIsvisible(true);
            setAuthFailMsg(false)
          
        } else {
            setloginMessage(res2.message);
            setAuthFailMsg(true);
            setIsvisible(true);
            setAuthSuccessMsg(false)
        }

            window.setTimeout(()=> setIsvisible(false), 3000)

    }


    return (
        <div className='login_form'>
            {/* <Lang /> */}
            <form className="center">
                <div className="align-self-center  login_wrap">
                    <div className="logowrap">
                        <Logo />
                    </div>
                    <h1 className="mb-2">{lang.forgot_password.title}</h1>
                    <div className="gmsg">{lang.forgot_password.message}</div>
                    <div className="form_wrap">
                        <div className="mb-3">
                            <label htmlFor="username" className="form-label">{lang.forgot_password.email}</label>
                            <input className="form-control" type="text" id="username" placeholder={lang.forgot_password.email} value={userName} onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <button type="submit" className="buttonAlliancePrimary btnlogin mb-3" onClick={forgotPass}>{lang.forgot_password.submit}</button>
                        </div>
                    </div>
                    <div className="center_nav fpass"><Link href="/"><a>{lang.forgot_password.return}</a></Link></div>
                    <Alert className="auth_message" color={`${AuthFailMsg ? "danger" : AuthSuccessMsg ? "success" : ""}`} isOpen={isVisible}>{loginMessage}</Alert>
                    
                </div>
            </form>
        </div>
  );
};


export default ForgotPassword;
